import { SUBTRAMITES_CONFIG } from "@/subtramites/constants";
import { getSubtramiteFromTramite } from "@/subtramites/getSubtramiteFromTramite";
import { SubtramiteEstado, SubtramiteKey } from "@/subtramites/types";

export const useTramiteStatusSummary = (tramite) => {
  const subtramites = Object.entries(SUBTRAMITES_CONFIG).map(([key, config]) => {
    const subtramite = getSubtramiteFromTramite(key as SubtramiteKey, tramite);
    return {
      label: subtramite?.label ?? (typeof config.label === 'function' ? config.label(subtramite) : config.label),
      status: subtramite?.estado ?? 'pendiente',
    };
  });


  const completed = subtramites.filter(subtramite => subtramite.status === 'finalizado').length;
  const totalEnabled = subtramites.filter(subtramite => subtramite.status !== 'pendiente').length;
  const progressPercentage = totalEnabled > 0
    ? (completed / totalEnabled) * 100
    : 0;

  const stats: Record<SubtramiteEstado, number> = {
    "en-proceso": totalEnabled - completed,
    "pendiente": subtramites.filter(subtramite => subtramite.status === 'pendiente').length,
    "finalizado": completed,
  }

  return {
    completed,
    totalEnabled,
    progressPercentage,
    stats,
    subtramites
  };
}